import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Button,
} from "@mui/material";

const AddTicketsDialog = ({
  open,
  onClose,
  addTicketsAmount,
  setAddTicketsAmount,
  addTicketsHandler,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Add Tickets</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sx={{ m: 0, p: 1 }}>
            <TextField
              id="amount"
              label="Amount"
              fullWidth
              value={addTicketsAmount}
              variant="standard"
              onChange={(e) => setAddTicketsAmount(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={addTicketsHandler} autoFocus disabled={false}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTicketsDialog;
